<template>
    <div class="page-title">
        <h1><i v-if="icon" :class="icon"></i> {{ main }}</h1>
        <h2>{{ sub }}</h2>
        <hr class="hrPageTitle">
    </div>
</template>

<script>
export default {
    name: 'PageTitle',
    props: ['icon', 'main', 'sub']
}
</script>

<style>
.page-title h1 {
    margin: 0px;
    padding-left:  20px;
    padding-top: 30px;
    color: #2e2d2c;
    font-family: 'Play';
    font-weight: bold;
}

.page-title h2 {
    color: #777;
    margin-top: 5px;
    font-size: 1.5rem;
    padding-left:  20px;
}
.hrPageTitle {
    border: 1px solid #008fac;
    padding: 0px 20px;
}
</style>